import type { DatepickerConfig } from '@demvsystems/design-components';

import { getDay100YearsBefore } from '@/utils/dates/dates';

export const birthdayConfig: DatepickerConfig = {
  lowerLimit: getDay100YearsBefore(),
  upperLimit: new Date(),
};
